<template>
    <v-layout class="my-4 border">
        <v-flex class="pa-2">
            <accessible-radio-group
                v-model="localeValue"
                :outline="outline"
                :name="metadata.name"
                :data-meta-id="metadata.id"
                :label="$t('appt.coveredRamq.title')"
                :options="[
                    { label: $t('appt.coveredRamq.child6MonthTo17Years'), value: 1 },
                    { label: $t('appt.coveredRamq.adultChronicDisease'), value: 2 },
                    { label: $t('appt.coveredRamq.pregnant'), value: 3 },
                    { label: $t('appt.coveredRamq.person75AndMore'), value: 4 },
                    { label: $t('appt.coveredRamq.child6MonthTo23Month'), value: 5 },
                    { label: $t('appt.coveredRamq.person60To74'), value: 6 },
                    { label: $t('appt.coveredRamq.caregiver'), value: 7 },
                    { label: $t('appt.coveredRamq.healthCareWorker'), value: 8 },
                    { label: $t('appt.coveredRamq.none'), value: 0 },
                ]"
                :mandatory="required"
                :rules="[
                    v => !required || v === 0 || v >= 1 || $t('base.errors.formQuestion')
                ]"
                :id="metadata.name"
                @input="emitValue"
            />
        </v-flex>
    </v-layout>
</template>

<script>
import { formRules } from '@/mixins/form-rules';
import { cloneDeep } from 'lodash';
import AccessibleRadioGroup from '@/components/inputs/AccessibleRadioGroup.vue';

export default {
    name: 'covered-ramq',
    components: { AccessibleRadioGroup },
    mixins: [formRules],
    data() {
        return {
            localeValue: {},
        };
    },
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: [String, Boolean, Number], required: false, default: '' },
        placeholder: { type: String, required: false, default: '' },
    },
    created() {
        this.localeValue = cloneDeep(this.value);
    },
    computed: {
        appendIcon() {
            return this.withIcon ? 'fas fa-user-friends' : '';
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value >= 1 ? 1 : 0);
        },
    },
};
</script>

<style lang="scss" scoped>
.border::v-deep {
    border: 2px solid var(--v-border-metadata-color)!important;
    border-radius: 4px!important;
}
</style>
